/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutomationCondition } from './AutomationCondition';
import {
    AutomationConditionFromJSON,
    AutomationConditionFromJSONTyped,
    AutomationConditionToJSON,
    AutomationConditionToJSONTyped,
} from './AutomationCondition';
import type { AutomationActionConfig } from './AutomationActionConfig';
import {
    AutomationActionConfigFromJSON,
    AutomationActionConfigFromJSONTyped,
    AutomationActionConfigToJSON,
    AutomationActionConfigToJSONTyped,
} from './AutomationActionConfig';

/**
 * 
 * @export
 * @interface AutomationRule
 */
export interface AutomationRule {
    /**
     * 
     * @type {number}
     * @memberof AutomationRule
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof AutomationRule
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof AutomationRule
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AutomationRule
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutomationRule
     */
    triggerType: AutomationRuleTriggerTypeEnum;
    /**
     * 
     * @type {Array<AutomationCondition>}
     * @memberof AutomationRule
     */
    conditions: Array<AutomationCondition>;
    /**
     * 
     * @type {string}
     * @memberof AutomationRule
     */
    actionType: AutomationRuleActionTypeEnum;
    /**
     * 
     * @type {AutomationActionConfig}
     * @memberof AutomationRule
     */
    actionConfig: AutomationActionConfig;
    /**
     * 
     * @type {boolean}
     * @memberof AutomationRule
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof AutomationRule
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof AutomationRule
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AutomationRule
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const AutomationRuleTriggerTypeEnum = {
    ClaimCreated: 'claim_created'
} as const;
export type AutomationRuleTriggerTypeEnum = typeof AutomationRuleTriggerTypeEnum[keyof typeof AutomationRuleTriggerTypeEnum];

/**
 * @export
 */
export const AutomationRuleActionTypeEnum = {
    SendForm: 'send_form'
} as const;
export type AutomationRuleActionTypeEnum = typeof AutomationRuleActionTypeEnum[keyof typeof AutomationRuleActionTypeEnum];


/**
 * Check if a given object implements the AutomationRule interface.
 */
export function instanceOfAutomationRule(value: object): value is AutomationRule {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('triggerType' in value) || value['triggerType'] === undefined) return false;
    if (!('conditions' in value) || value['conditions'] === undefined) return false;
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    if (!('actionConfig' in value) || value['actionConfig'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function AutomationRuleFromJSON(json: any): AutomationRule {
    return AutomationRuleFromJSONTyped(json, false);
}

export function AutomationRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationRule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'triggerType': json['triggerType'],
        'conditions': ((json['conditions'] as Array<any>).map(AutomationConditionFromJSON)),
        'actionType': json['actionType'],
        'actionConfig': AutomationActionConfigFromJSON(json['actionConfig']),
        'isActive': json['isActive'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function AutomationRuleToJSON(json: any): AutomationRule {
    return AutomationRuleToJSONTyped(json, false);
}

export function AutomationRuleToJSONTyped(value?: AutomationRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'name': value['name'],
        'description': value['description'],
        'triggerType': value['triggerType'],
        'conditions': ((value['conditions'] as Array<any>).map(AutomationConditionToJSON)),
        'actionType': value['actionType'],
        'actionConfig': AutomationActionConfigToJSON(value['actionConfig']),
        'isActive': value['isActive'],
        'createdBy': value['createdBy'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

